<template v-on:scroll.native="handleScroll">
  <!-- :class="{'bgh-white': !view.topOfPage, 'bgh-orange': view.topOfPage}" -->
    <header class="header header-top">
        <nav class="navbar navbar-expand-lg header-nav">
            <div class="navbar-header">
                 <template v-if="isLoggedIn">
                        
                        <a id="mobile_btn" href="javascript:void(0);" v-if="user.hak_akses!='1'">
                        <span class="bar-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                        </span>
                        </a>
                        <router-link to="/index" class="mobile_btn" v-if="user.hak_akses=='1'">
                        <span class="bar-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="auto" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"></path></svg>
                        </span>
                        </router-link>
                    </template>
                    
                    <template v-else>                        
                        <!-- <a id="mobile_btn" href="" > -->
                        <router-link to="/login" class="mobile_btn">

                        <!-- <span class="bar-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                        </span>
                        </a> -->
                        <span class="bar-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="auto" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/></svg>
                        </span>
                        </router-link>
                    </template>

                <a href="/" class="navbar-brand logo" v-if="!isLoggedIn">
                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                </a>
                
                <a href="/index" class="navbar-brand logo" v-if="isLoggedIn">
                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                </a>
                <!-- <router-link to="/index-front.html" class="navbar-brand logo">
                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                </router-link> -->

                <router-link id="mobile_btn_right" to="/siswa/transaksi" class="cart">
                    <div class="cart-item">
                    <i class="fas fa-shopping-cart"></i>
                    <span class="badge badge-pill">{{cntPaketWaiting}}</span>
                    </div>
                </router-link>
            </div>
            <div class="main-menu-wrapper">
                <div class="menu-header">
                    
                    <a href="/" class="menu-logo" v-if="!isLoggedIn">
                    <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                    </a>
                    
                    <a href="/index" class="menu-logo" v-if="isLoggedIn">
                    <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                    </a>

                    <!-- <a href="/" class="menu-logo">
                      <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                    </a> -->
                    <!-- <router-link to="/index-front.html" class="menu-logo">
                      <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                    </router-link> -->
                    <a id="menu_close" class="menu-close" href="javascript:void(0);">
                    <i class="fas fa-times"></i>
                    </a>
                </div>
                
                <ul class="main-nav bg-trans">
                    <li>
                        <!-- <router-link to="/index-front.html" class="home-nav">
                            <i class="fas fa-home mobile_btn"></i>
                            Home
                        </router-link> -->
                        <a href="/" class="home-nav">
                            <i class="fas fa-home mobile_btn"></i>
                            Home
                        </a>
                    </li>
                    <li>
                        <router-link to="/index" class="home-nav">
                            <i class="fas fa-list mobile_btn"></i>
                            Kategori
                        </router-link>
                    </li>
                    <!-- <li class="has-submenu" :class="{'active': instructorMenu}">
                        <a href="">Instructors <i class="fas fa-chevron-down"></i></a>
                        <ul class="submenu">
                            <li class="sub-menu"  v-bind:class="{'active': currentPath == 'instructor-dashboard' }"><router-link to="/instructor/dashboard">Instructors Dashboard</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'instructor-appointments' }"><router-link to="/instructor/appointments">Appointments</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'instructors' }"><router-link to="/instructors">Instructors List</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'instructor-profile' }"><router-link to="/instructor/profile">Instructor Profile</router-link></li>
                            <li class="sub-menu"><router-link to="/instructor/chat">Chat</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'instructor-profile-settings' }"><router-link to="/instructor/profile-settings">Profile Settings</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'instructor-reviews' }"><router-link to="/instructor/reviews">Reviews</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'instructor-register'}"><router-link to="/instructor/register">Instructor Register</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'instructor-change-password'}"><router-link to="/instructor/change-password">Change Password</router-link></li>
                        </ul>
                    </li>
                    <li class="has-submenu" :class="{'active': schoolMenu}">
                        <a href="">Schools <i class="fas fa-chevron-down"></i></a>
                        <ul class="submenu">
                            <li class="has-submenu" :class="{'active': instructorMapMenu}">
                                <a href="#">School List</a>
                                <ul class="submenu">
                                    <li class="sub-menu"  v-bind:class="{'active': currentPath == 'map-grid'}"><router-link to="/map-grid">Map Grid</router-link></li>
                                    <li class="sub-menu" v-bind:class="{'active': currentPath == 'map-list'}"><router-link to="/map-list">Map List</router-link></li>
                                </ul>
                            </li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'search-school'}"><router-link to="/search">Search School</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'school-profile'}"><router-link to="/profile">School Profile</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'school-dashboard'}"><router-link to="/dashboard">School Dashboard</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'schedule-timings'}"><router-link to="/schedule-timings">Schedule Timing</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'booking'}"><router-link to="/booking">Booking</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'checkout'}"><router-link to="/checkout">Checkout</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'booking-success'}"><router-link to="/booking-success">Booking Success</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'invoices'}"><router-link to="/invoices">Invoices</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'instructor-chat'}"><router-link to="/instructor/chat">Chat</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'school-profile-settings'}"><router-link to="/profile-settings">Profile Settings</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'school-change-password'}"><router-link to="/change-password">Change Password</router-link></li>
                        </ul>
                    </li>
                    <li class="has-submenu" :class="{'active': courseMenu}">
                        <a href="">Courses <i class="fas fa-chevron-down"></i></a>
                        <ul class="submenu">
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'course-list'}"><router-link to="/course">Course List</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'course-details'}"><router-link to="/course/details">Course Details</router-link></li>
                            <li><router-link to="/booking">Course Book</router-link></li>
                        </ul>
                    </li>
                    <li class="has-submenu" :class="{'active': pagesMenu}">
                        <a href="">Pages <i class="fas fa-chevron-down"></i></a>
                        <ul class="submenu">
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'voice-call'}"><router-link to="/voice-call">Voice Call</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'video-call'}"><router-link to="/video-call">Video Call</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'calendar'}"><router-link to="/calendar">Calendar</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'components'}"><router-link to="/components">Components</router-link></li>
                            <li  class="has-submenu" :class="{'active': invoicesMenu}">
                                <a href="">Invoices</a>
                                <ul class="submenu">
                                    <li class="sub-menu"><router-link to="/invoices">Invoices</router-link></li>
                                    <li class="sub-menu" v-bind:class="{'active': currentPath == 'invoice-view'}"><router-link to="/invoice/view">Invoice View</router-link></li>
                                </ul>
                            </li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'starter-page'}"><router-link to="/blank-page">Starter Page</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'login-page'}"><router-link to="/login">Login</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'register-page'}"><router-link to="/register">Register</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'forgot-password'}"><router-link to="/forgot-password">Forgot Password</router-link></li>
                        </ul>
                    </li>
                    <li class="has-submenu" :class="{'active': blogsMenu}">
                        <a href="">Blog <i class="fas fa-chevron-down"></i></a>
                        <ul class="submenu">
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'blog-list'}"><router-link to="/blog/list">Blog List</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'blog-grid'}"><router-link to="/blog/grid">Blog Grid</router-link></li>
                            <li class="sub-menu" v-bind:class="{'active': currentPath == 'blog-details'}"><router-link to="/blog/details">Blog Details</router-link></li>
                        </ul>
                    </li> -->
                    <li class="searchbar">
                        <i class="fa fa-search" aria-hidden="true"></i>
                        <div class="togglesearch">
                            <input type="text" placeholder="" class="top-search">
                            <button class="btn btn-toogle">search</button>
                        </div>
                    </li>
                    
                    <template v-if="isLoggedIn">
                        
                        <li class="nav-item cart notmobile_menu">
                            <router-link to="/siswa/transaksi" class="cart-item">
							<!-- <a href="checkout.html" class="cart-item"> -->
								<i class="fas fa-shopping-cart"></i>
								<span class="badge badge-pill">{{cntPaketWaiting}}</span>
							<!-- </a> -->
                            </router-link>
						</li>

                        <li class="nav-item">
                            <router-link class="home-nav" :to="'/'+((user.hak_akses=='3')?'admin':((user.hak_akses=='2')?'instructor':'siswa'))+'/profile-settings'" > 
                                <i class="fas fa-user-cog mobile_btn"></i>
                                <span> Hi {{user.namauser}} </span>
                            </router-link>
                        </li>
                        
                        <template v-if="user.hak_akses=='1' || user.hak_akses=='4'">
                            <li class="nav-item mobile_btn" v-if="user.hak_akses=='4'">
                                <router-link to="/mitra/penjualan" class="home-nav">
                                    <i class="fas fa-columns"></i>
                                    <span>Penjualan</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/siswa/paket-saya" class="home-nav">
                                    <i class="fas fa-heart"></i>
                                    <span>Paket Saya</span>
                                    <!-- <small class="unread-msg"></small> -->
                                </router-link>
                            </li> 
                            <!-- <li class="nav-item mobile_btn">
                                <router-link to="/index" class="home-nav">
                                    <i class="fas fa-cart-plus"></i>
                                    <span>Paket Saya</span>
                                </router-link>
                            </li>  -->
                            <li class="nav-item mobile_btn">
                                <router-link to="/siswa/transaksi" class="home-nav">
                                    <i class="fas fa-calendar-check"></i>
                                    <span>Transaksi</span>
                                </router-link>
                            </li> 
                            <li class="nav-item mobile_btn">
                                <router-link to="/siswa/learndoteach" class="home-nav">
                                    <span>#LearnDoTeach</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/siswa/wallet" class="home-nav">
                                    <span>Komisi </span>
                                </router-link>
                            </li>
                        </template>
                        
                        <template v-if="user.hak_akses=='2'">
                            <li class="nav-item mobile_btn">
                                <router-link to="/index" class="home-nav">
                                    <i class="fas fa-cart-plus"></i>
                                    <span>Paket Belajar</span>
                                    <!-- <small class="unread-msg">{{cntPaket}}</small> -->
                                </router-link>
                            </li> 
                            <li class="nav-item mobile_btn">
                                <router-link to="/instructor/instansi" class="home-nav">
                                    <i class="fas fa-building"></i>
                                    <span>Instansi</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/instructor/rekam-jejak" class="home-nav">
                                    <i class="fas fa-history"></i>
                                    <span>Rekam Jejak</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="" class="home-nav">
                                    <!-- <i class="fas fa-wallet"></i> -->
                                    <span>Keuangan</span>
                                    <small  class="unread-msg-mobile badge badge-pill bg-warning-light">Coming Soon</small>                                
                                </router-link>
                            </li>
                            
                            <li class="nav-item mobile_btn">
                                <router-link to="/instructor/materi" class="home-nav">
                                    <i class="fas fa-list"></i>
                                    <span>Manajemen Materi</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/instructor/tryout" class="home-nav">
                                    <i class="fas fa-list"></i>
                                    <span>Manajemen Try Out</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="" class="home-nav">
                                    <!-- <i class="fas fa-calendar-check"></i> -->
                                    <span>Kelas Pendidik</span>
                                    <small  class="unread-msg-mobile badge badge-pill bg-warning-light">Coming Soon</small>                                
                                    <!-- <small class="unread-msg">23</small> -->
                                </router-link>
                            </li> 
                            <li class="nav-item mobile_btn">
                                <router-link to="" class="home-nav">
                                    <!-- <i class="fas fa-columns"></i> -->
                                    <span>#LearnDoTeach</span>
                                    <small  class="unread-msg-mobile badge badge-pill bg-warning-light">Coming Soon</small>                                
                                </router-link>
                            </li>                        
                            <li class="nav-item mobile_btn">
                                <router-link to="" class="home-nav">
                                    <!-- <i class="fas fa-comments"></i> -->
                                    <span>Referral</span>
                                    <small  class="unread-msg-mobile badge badge-pill bg-warning-light">Coming Soon</small>                                
                                </router-link>
                            </li>
                        </template>
                        
                        <template v-if="user.hak_akses == '3'">
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/ref-home" class="home-nav">
                                    <i class="fas fa-list"></i>
                                    <span>Manajemen Home</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/ref-tingkatan" class="home-nav">
                                    <i class="fas fa-list"></i>
                                    <span>Manajemen Referensi</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/materi" class="home-nav">
                                    <i class="fas fa-list"></i>
                                    <span>Manajemen Materi</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/tryout" class="home-nav">
                                    <i class="fas fa-list"></i>
                                    <span>Manajemen Try Out</span>
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/kelas-saya" class="home-nav">
                                    <i class="fas fa-calendar-check"></i>
                                    <span>Manajemen Paket</span>
                                    <!-- <small class="unread-msg">{{cntPaket}}</small> -->
                                </router-link>
                            </li>                             
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/bimbel" class="home-nav">
                                    <i class="fas fa-calendar-check"></i>
                                    <span>Manajemen Bimbel</span>
                                </router-link>
                            </li> 
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/user" class="home-nav">
                                    <i class="fas fa-users"></i>
                                    <span>Manajemen User</span>
                                    <!-- <small class="unread-msg">{{cntUser}}</small> -->
                                </router-link>
                            </li>                                                 
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/wallet" class="home-nav">
                                    <i class="fas fa-wallet"></i>
                                    <span>Manajemen Referral</span>
                                    <small class="-mobile badge badge-pill bg-primary-light">NEW</small>                                                                 
                                </router-link>
                            </li>
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/penjualan" class="home-nav">
                                    <i class="fas fa-columns"></i>
                                    <span>Penjualan</span>
                                    <!-- <small class="unread-msg">{{cntPenjualan}}</small> -->
                                </router-link>
                            </li>
                                               
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/laporsoal" class="home-nav">
                                    <i class="fas fa-files"></i>
                                    <span>Laporan Soal</span>                                                           
                                </router-link>
                            </li>                 
                            <li class="nav-item mobile_btn">
                                <router-link to="/admin/rank" class="home-nav">
                                    <i class="fas fa-trophy"></i>
                                    <span>Peringkat Hasil Tryout</span>                                                            
                                </router-link>
                            </li>  
                        </template>
                        
                            <li class="nav-item mobile_btn">                            
                                <a @click="logout" class="home-nav">
                                    <i class="fas fa-sign-out-alt"></i>
                                    <span>Keluar</span>
                                </a>
                            </li>

                    </template>                     
                    <template v-else>                        
                        <li class="login-link">
                            <router-link to="/login" class="home-nav">Login / Signup</router-link>
                        </li>
                    </template>
                </ul>
            </div>
            <ul class="nav header-navbar-rht align-items-center">
                
                    <template v-if="isLoggedIn">
                        <li class="nav-item contact-item">
                            <a @click="logout">Keluar</a>
                        </li>
                    </template>
                    <template v-else>                        
                        <li class="nav-item contact-item">
                            <router-link to="/login">Login / Signup</router-link>
                        </li>
                    </template>
                
            </ul>
        </nav>
        <!-- <ul class="kt-sticky-toolbar" style="margin-top: 30px;">
			<li class="kt-sticky-toolbar__item kt-sticky-toolbar__item--success" id="kt_demo_panel_toggle" data-toggle="kt-tooltip" title="" data-placement="right" data-original-title="Check out more demos">
                <a  href="https://wa.me/+6285183033543" target="_blank" >
                    <img src="https://img.icons8.com/external-smashingstocks-flat-smashing-stocks/96/000000/external-customer-service-tech-support-mentoring-and-training-smashingstocks-flat-smashing-stocks-4.png">
                </a>
            </li>
        </ul> -->
    </header>
</template>


<script>
import Util from '../../../assets/utils/utils'
import {mapGetters} from 'vuex'
import axios from 'axios';

export default {
    
    data() {
        return {
            scrollTop: 0,
            view: {
                topOfPage: true
            },
            cntPaketWaiting: 0,
        }
    },
    created () {
            window.addEventListener('scroll', this.handleScroll, true);
        
        this.getCntPaketWaiting();
    },
    // beforeMount() {
    //     window.addEventListener('scroll', this.handleScroll)
    // },,created: function () {
       
    methods: {
        getCntPaketWaiting: function () {
            if(this.isLoggedIn){
            axios.get('api/cntpaketwaiting')
                .then(res => {
                    this.cntPaketWaiting = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
            }
        },
        handleScroll(){
            this.scrollTop = ((document.documentElement.scrollTop!==null)?document.documentElement.scrollTop:0) ||
                        window.pageYOffset ||
                        document.body.scrollTop ||
                        document.querySelector(this.el).scrollTop;
            // console.log("bismillah : " + this.scrollTop);   

            if(this.scrollTop>200){
                if(this.view.topOfPage) this.view.topOfPage = false
            } else {
                if(!this.view.topOfPage) this.view.topOfPage = true
            }
        },
    
        logout: function() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
            });
        }, 
    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
        currentPath() {
            return this.$route.name
        },
        instructorMenu() {
            return Util.instructorMenu(this.$route.name)
        },
        instructorMapMenu() {
            return Util.instructorMapMenu(this.$route.name)
        },
        invoicesMenu() {
            return Util.invoicesMenu(this.$route.name)
        },
        schoolMenu() {
            return Util.schoolMenu(this.$route.name)
        },
        courseMenu() {
            return Util.courseMenu(this.$route.name)
        },
        pagesMenu() {
            return Util.pagesMenu(this.$route.name)
        },
        blogsMenu() {
            return Util.blogsMenu(this.$route.name)
        },        
        
    },
    mounted() {
        // window.addEventListener('scroll', this.handleScroll)
        // $(window).scroll(function(){
        //     console.log($(window).scrollTop());
        //         if($(window).scrollTop() > 0){
        //             // this.view.topOfPage = false
        //             $("#header").css({"background-color":"#fff !important"});   
        //         }
        //         else{
        //             $("#header").css({"background-color":"#f5ead8 !important"});   
        //         }

        // })
        $(document).ready(function() {
            $(".fa-search").click(function() {
            $(".togglesearch").toggle();
            $(".top-search").focus();
            });
                    window.onscroll =  () => {
                if ( $(window).scrollTop() > 250 ) {
                        $('.header').addClass('sticky');
                    } else {
                        $('.header').removeClass('sticky');
                    }
            };

            $('.main-nav a').on('click', function(e) {
                if($(this).parent().hasClass('has-submenu')) {
                    e.preventDefault();
                }
                if(!$(this).hasClass('submenu')) {                    
                    $('ul', $(this).parents('ul:first')).slideUp(350);
                    $('a', $(this).parents('ul:first')).removeClass('submenu');
                    $(this).next('ul').slideDown(350);
                    $(this).addClass('submenu');
                } else if($(this).hasClass('submenu')) {
                    $(this).removeClass('submenu');
                    $(this).next('ul').slideUp(350);
                }
            });

            $('.main-nav > li .submenu li.sub-menu').on('click', function(e) {
                $('html').removeClass('menu-opened');
                $('.sidebar-overlay').removeClass('opened');
                $('main-wrapper').removeClass('slide-nav');
            });

            $('body').append('<div class="sidebar-overlay"></div>');
            $(document).on('click', '#mobile_btn', function() {
                $('main-wrapper').toggleClass('slide-nav');
                $('.sidebar-overlay').toggleClass('opened');
                $('html').addClass('menu-opened');
                return false;
            });

            $(document).on('click', '.sidebar-overlay', function() {
                $('html').removeClass('menu-opened');
                $(this).removeClass('opened');
                $('main-wrapper').removeClass('slide-nav');
            });
            
            $(document).on('click', '#menu_close', function() {
                $('html').removeClass('menu-opened');
                $('.sidebar-overlay').removeClass('opened');
                $('main-wrapper').removeClass('slide-nav');
            });

            $('.main-nav li .home-nav').click(function(){
                $("html").removeClass('menu-opened');         
                $(".sidebar-overlay").removeClass('opened');
            }); 

            
            
	    });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Layout/HeaderMain/index.vue